import routes from './routes'

export const buildLocalizedPath = (pageId, locale) => {
  return routes[locale][pageId] 
}